import React, { PureComponent, Fragment } from 'react';

import SnapChatVisitorsByMonth from "./../Graphs/SnapChatVisitorsByMonth"
import { DemographicsPieChart } from "./../Graphs/Demographics"
import { DemographicsBarChart } from "./../Graphs/Demographics"
import moment from "moment";

import { Metric, Error } from './../../Utils/Utils.js';
import Heading from '../../Elements/Heading';

class SnapChatSummary extends PureComponent {

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return (
        <Error minHeight={360} />
      );
    }

    const labelFmt = d => moment(d).utc().format('DD-MMM')
    const prepareData = d => {
      d.value = d.count;
      d.label = labelFmt(d.label)
    }
    const prepareTimeData = d => {
      if (d.count) {
        const sec = d.count.split(":").map(d => +d);
        d.value = 60 * sec[0] + sec[1];  
      } else {
        d.value = 0; 
      }
      d.displayedValue = d.count;
      d.label = labelFmt(d.label)
    }
    const sort = (a, b) => b.label > a.label ? -1 : 1

    data.uniqueViewers.total.byDay.forEach(prepareData)
    data.uniqueViews.total.byDay.forEach(prepareData)
    data.timeViewed.total.byDay.forEach(prepareData)

    data.uniqueViewers.daily.byDay = data.uniqueViewers.daily.byDay.sort(sort)
    data.uniqueViewers.daily.byDay.forEach(prepareData)

    data.uniqueViews.daily.byDay = data.uniqueViews.daily.byDay.sort(sort)
    data.uniqueViews.daily.byDay.forEach(prepareData)

    data.timeViewed.daily.byDay.forEach(prepareTimeData)

    data.avgViewsPerStory.byDay.forEach(prepareData)

    data.totalEpisodesPublished.byDay = data.totalEpisodesPublished.byDay.sort((a, b) => b.date > a.date ? -1 : 1)
    data.totalEpisodesPublished.byDay.forEach(d => d.label = labelFmt(d.date))

    data.avgViewsPerEpisode.byDay = data.avgViewsPerEpisode.byDay.sort((a, b) => b.date > a.date ? -1 : 1)
    data.avgViewsPerEpisode.byDay.forEach(d => d.label = labelFmt(d.date))

    return (
      <Fragment>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <Heading size={3} className="mb-4">{this.props.group_name}</Heading>
            </div>

            <div className="row justify-content-center">
              <div className="col-auto col-sm-6 col-lg-3">
                <div className="row mb-4">
                  <div className="col">
                    <Heading size={6}>Total Unique Viewers</Heading>
                    <Metric {...data.uniqueViewers.total.trend} graph={data.uniqueViewers.total.byDay} size={"lg"} />
                    <div className="metric-label">Last 31 Days</div>
                  </div>
                </div>

                <div className="row mb-4 pt-1">
                  <div className="col">
                    <Heading size={6}>Daily Unique Viewers</Heading>
                    <Metric {...data.uniqueViewers.daily.trend} graph={data.uniqueViewers.daily.byDay} size={"lg"} />
                    <div className="metric-label">31 Day Avg</div>
                  </div>
                </div>

                <div className="row timeline mb-4 pt-1">
                  <div className="col">
                    <div className="row mb-3">
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">Last 7</Heading>
                        <Metric value={data.uniqueViewers.daily.last7} size={"sm"} />
                      </div>
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">YTD</Heading>
                        <Metric value={data.uniqueViewers.daily.ytd} size={"sm"} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-auto col-sm-auto col-lg-3">
                <div className="row mb-4">
                  <div className="col">
                    <Heading size={6}>Unique Topsnap Views</Heading>
                    <Metric {...data.uniqueViews.total.trend} graph={data.uniqueViews.total.byDay} size={"lg"} />
                    <div className="metric-label">Last 31 Days</div>
                  </div>
                </div>

                <div className="row mb-4 pt-1">
                  <div className="col">
                    <Heading size={6}>Daily Unique Views</Heading>
                    <Metric {...data.uniqueViews.daily.trend} graph={data.uniqueViews.daily.byDay} size={"lg"} />
                    <div className="metric-label">31 Day Avg</div>
                  </div>
                </div>

                <div className="row timeline mb-4 pt-1">
                  <div className="col">
                    <div className="row mb-3">
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">Last 7</Heading>
                        <Metric value={data.uniqueViews.daily.last7} size={"sm"} />
                      </div>
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">YTD</Heading>
                        <Metric value={data.uniqueViews.daily.ytd} size={"sm"} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-auto col-sm-6 col-lg-3">
                <div className="row mb-4">
                  <div className="col">
                    <Heading size={6}>Total Time Viewed</Heading>
                    <Metric {...data.timeViewed.total.trend} graph={data.timeViewed.total.byDay} size={"lg"} />
                    <div className="metric-label">mins - Last 31 Days</div>
                  </div>
                </div>

                <div className="row mb-4 pt-1">
                  <div className="col">
                    <Heading size={6}>Daily Time Viewed</Heading>
                    <Metric {...data.timeViewed.daily.trend} type="time"
                      graph={data.timeViewed.daily.byDay} size={"lg"} />
                    <div className="metric-label">mins - 31 Day Avg</div>
                  </div>
                </div>

                <div className="row timeline mb-4 pt-1">
                  <div className="col">
                    <div className="row mb-3">
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">Last 7</Heading>
                        <Metric value={data.timeViewed.daily.last7} type="time" size={"sm"} />
                        <Heading size={6} className="metric__label mb-0 pb-0">mins</Heading>
                      </div>
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">YTD</Heading>
                        <Metric value={data.timeViewed.daily.ytd}  type="time" size={"sm"} />
                        <Heading size={6} className="metric__label mb-0 pb-0">mins</Heading>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-auto col-sm-auto col-lg-3">
                <div className="row mb-4" style={{ visibility: 'hidden' }}>
                  <div className="col">
                    <Heading size={6}>Daily Core Viewers</Heading>
                    <Metric {...data.timeViewed.total.trend} graph={data.timeViewed.total.byDay} size={"lg"} />
                    <div className="metric-label">mins - Last 31 Days</div>
                  </div>
                </div>

                <div className="row mb-4 pt-1">
                  <div className="col">
                    <Heading size={6}>Avg Views Per Story</Heading>
                    <Metric {...data.avgViewsPerStory.trend} graph={data.avgViewsPerStory.byDay} size={"lg"} />
                    <div className="metric-label">31 Day Avg</div>
                  </div>
                </div>

                <div className="row timeline mb-4 pt-1">
                  <div className="col">
                    <div className="row mb-3">
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">Last 7</Heading>
                        <Metric value={data.avgViewsPerStory.last7} size={"sm"} />
                      </div>
                      <div className="col-6 col-sm-4 mb-2 timeline-item">
                        <Heading size={6} className="metric__label">YTD</Heading>
                        <Metric value={data.avgViewsPerStory.ytd} size={"sm"} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="row mb-2">

              <div className="col-12 col-md-6 mb-3">
                <div className="row">
                  <div className="col-6">
                    <Heading size={6}>Total Episodes Published</Heading>
                    <Metric {...data.totalEpisodesPublished.trend}
                      graph={data.totalEpisodesPublished.byDay} size={"lg"} />
                    <div className="metric-label">Last 31 Days</div>
                  </div>
                  <div className="col-6">
                    <Heading size={6}>AVG Unique Topsnaps Per User</Heading>
                    <Metric {...data.avgViewsPerEpisode.trend}
                      graph={data.avgViewsPerEpisode.byDay} size={"lg"} />
                    <div className="metric-label">31 Day Avg</div>
                  </div>
                </div>
                <div className="row mt-4">
                  <Heading size={6} className={"mb-3"}>Demographics <span className="metric-label">31 Day Avg</span></Heading>
                </div>
                <div className="row mt-2">
                  <div className="col-5">
                    <DemographicsPieChart data={{ graph: data.demographic.genderGraph }} />
                  </div>
                  <div className="col-5">
                    <DemographicsBarChart data={{ graph: data.demographic.ageGraph }} />
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <div className="row">
                  <div className="col-12">
                    <Heading size={6} className={"mb-3"}>Unique Views By Month</Heading>
                    <SnapChatVisitorsByMonth data={data.uniqueViews.byMonth.graph} goal={data.uniqueViews.byMonth.avg} />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-12">
                    <Heading size={6} className={"mb-3"}>Time Viewed By Month</Heading>
                    <SnapChatVisitorsByMonth data={data.timeViewed.byMonth.graph} goal={data.timeViewed.byMonth.avg} />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </Fragment>
    );
  }
}

export default SnapChatSummary
